const TOKEN = 'adminToken';
const USER = 'adminData';
const REFRESH = 'adminRefreshToken';
const ACTIVITY = 'adminLastActivity';
let timeoutMs = 900000;
export function configureSessionTimeout(value) {
  if (Number.isFinite(value) && value >= 60000) timeoutMs = value;
}
export function sessionTimeout() {
  return timeoutMs;
}
export function lastActivity() {
  return Number(localStorage.getItem(ACTIVITY)) || 0;
}
export function markActivity(now = Date.now()) {
  localStorage.setItem(ACTIVITY, String(now));
}
export function sessionIsIdle(now = Date.now()) {
  return lastActivity() > 0 && now - lastActivity() >= timeoutMs;
}
export function accessToken() {
  return localStorage.getItem(TOKEN);
}
export function refreshToken() {
  return sessionStorage.getItem(REFRESH);
}
export function saveSession(user, token, refresh) {
  localStorage.setItem(USER, JSON.stringify(user));
  localStorage.setItem(TOKEN, token);
  if (refresh) sessionStorage.setItem(REFRESH, refresh);
  else sessionStorage.removeItem(REFRESH);
  markActivity();
}
export function saveRefreshedTokens(token, refresh) {
  localStorage.setItem(TOKEN, token);
  if (refresh) sessionStorage.setItem(REFRESH, refresh);
}
export function clearSession() {
  localStorage.removeItem(TOKEN);
  localStorage.removeItem(USER);
  localStorage.removeItem(ACTIVITY);
  sessionStorage.removeItem(REFRESH);
}
